module.exports = __webpack_public_path__ + "static/media/otherOptionsQuestion.dfd5e1bc.mp3";